export const BUSINESS_ACCOUNT_FETCH_CONSENT_START = "BUSINESS_ACCOUNT_FETCH_CONSENT_START";
export const BUSINESS_ACCOUNT_FETCH_CONSENT_DONE = "BUSINESS_ACCOUNT_FETCH_CONSENT_DONE";
export const BUSINESS_ACCOUNT_FETCH_CONSENT_FAILED = "BUSINESS_ACCOUNT_FETCH_CONSENT_FAILED";

export const BUSINESS_ACCOUNT_FETCH_STATE_START = "BUSINESS_ACCOUNT_FETCH_STATE_START";
export const BUSINESS_ACCOUNT_FETCH_STATE_DONE = "BUSINESS_ACCOUNT_FETCH_STATE_DONE";
export const BUSINESS_ACCOUNT_FETCH_STATE_FAILED = "BUSINESS_ACCOUNT_FETCH_STATE_FAILED";

export const BUSINESS_ACCOUNT_OPEN_START = "BUSINESS_ACCOUNT_OPEN_START";
export const BUSINESS_ACCOUNT_OPEN_DONE = "BUSINESS_ACCOUNT_OPEN_DONE";
export const BUSINESS_ACCOUNT_OPEN_FAILED = "BUSINESS_ACCOUNT_OPEN_FAILED";



// WEBPACK FOOTER //
// ./src/features/business_account/actionTypes.js